// api/publicMenuApi.js
import axios from "../utils/axios";

// ── Public Menu ───────────────────────────────────────────────────
export const getPublicMenuApi = (restaurantId) =>
  axios.get(`/api/public/menu/${restaurantId}`);

export const createWhatsAppOrderApi = (data) =>
  axios.post("/api/orders/whatsapp", data);

// ── Public Offers ─────────────────────────────────────────────────

// 1️⃣ Get all active offers
export const getPublicOffersApi = (restaurantId) =>
  axios.get(`/api/public/${restaurantId}`);

// 2️⃣ Validate offer code at checkout
export const validateOfferCodeApi = (data) =>
  axios.post("/api/public/validate", data);

// 3️⃣ Categories with offers
export const getCategoriesWithOffersApi = (restaurantId) =>
  axios.get(`/api/public/categories/with-offers/${restaurantId}`);

// 4️⃣ Menu items with offers
// ✅ FIX: URL changed from /menu/with-offers → /menu-with-offers
// (backend route renamed to avoid conflict with /menu/:restaurantId)
export const getMenuWithOffersApi = (restaurantId) =>
  axios.get(`/api/public/menu-with-offers/${restaurantId}`);

// 5️⃣ Apply offer to cart
export const applyOfferToCartApi = (data) =>
  axios.post("/api/public/apply-to-cart", data);

// Get Restaurant Details
export const getRestaurantApi = (restaurantId) => 
  axios.get(`/api/public/restaurant-details/${restaurantId}`);

// // Get All Restaurant Details
// export const getAllRestaurantsApi = (page = 1, limit = 8) =>
//   axios.get("/api/public", {
//     params: {
//       page,
//       limit,
//     },
//   });

export const getAllRestaurantsApi = (
  page = 1,
  limit = 8,
  search = "",
  state = "",
  city = "",
) =>
  axios.get("/api/public", {
    params: {
      page,
      limit,
      ...(search && { search }),
      ...(state && { state }),
      ...(city && { city }),
    },
  });
